var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { PrimaryButtonView } from './PrimaryButtonView';
import { SecondaryButtonView } from './SecondaryButtonView';
import { TertiaryButtonView } from './TertiaryButtonView';
import { BaseButtonView } from './BaseButtonView';
import { DenseButtonView } from './DenseButtonView';
import { ToggleButtonView } from './ToggleButtonView';
import { FabButtonView } from './FabButtonView';
import { UnderlineButtonView } from './UnderlineButtonView';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
const buttons = {
    underline: (props) => _jsx(UnderlineButtonView, Object.assign({}, props, { testID: props.testID || props.action })),
    primary: (props) => _jsx(PrimaryButtonView, Object.assign({}, props, { testID: props.testID || props.action })),
    secondary: (props) => _jsx(SecondaryButtonView, Object.assign({}, props, { testID: props.testID || props.action })),
    tertiary: (props) => _jsx(TertiaryButtonView, Object.assign({}, props, { testID: props.testID || props.action })),
    dense: (props) => _jsx(DenseButtonView, Object.assign({}, props, { testID: props.testID || props.action })),
    toggle: (props) => _jsx(ToggleButtonView, Object.assign({}, props, { testID: props.testID || props.action })),
    fab: (props) => _jsx(FabButtonView, Object.assign({}, props, { testID: props.testID || props.action })),
    default: (props) => _jsx(BaseButtonView, Object.assign({}, props, { testID: props.testID || props.action }))
};
let PressableButtonView = class PressableButtonView extends Component {
    render() {
        if (typeof buttons[this.props.type] !== 'function') {
            console.warn(`Button with type ${this.props.type} is not registered!`);
            return buttons.default(this.props);
        }
        return buttons[this.props.type](this.props);
    }
};
PressableButtonView = __decorate([
    component({
        provider: CoreConfig.provider,
        moduleName: CoreConfig.moduleName
    })
], PressableButtonView);
export { PressableButtonView };
